import {extractDateTime, isChildRow, isParentRow} from 'cl-table/VirtualizedHelpers';
import {Channels} from 'cl-api';
import SyncIcon from '@material-ui/icons/Sync';
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import DoneIcon from '@material-ui/icons/Done';
import TooltipIcon from '@material-ui/core/TooltipIcon';
import * as React from 'react';
import * as _ from 'lodash';
import {SYNC_STATUS} from 'cl-consts';
import {DEFAULT_FIELD_PROPS, FIELD_NAMES} from '../AmazonListings/consts';

export const VARIATION_OPTIONS_FIELDS = ['Brand', 'Material', 'Size', 'Color'];
export const VISIBLE_PRODUCT_FIELDS = [
  'SKU',
  'Price',
  'PriceEURO',
  'PriceGBP',
  'PriceAUD',
  'Quantity',
  'HandlingTime',
  'UPC',
  'EAN',
  'ASIN',
];
export const PRODUCT_VARIATIONS = 'Variations';
export const PRODUCT_VARIATIONS_SWITCH = 'VariationsSwitch';
export const PRODUCT_VARIATIONS_TABLE = 'variationsTable';
export const PRODUCT_LISTINGS_TABLE = 'productListingsTable';
export const PRODUCT_LISTINGS_COUNT = 'ListingsCount';
export const LISTING_COLUMNS = {
  CHANNEL: 'Channel',
  ACCOUNT: 'Account',
  SITE: 'Site',
  LISTING_TITLE: 'ListingTitle',
  LISTING_ID: 'ListingId',
  FULFILLED_BY: 'FulfilledBy',
  QUANTITY: 'Quantity',
  PRICE: 'Price',
  PRODUCT_SKU: 'ProductSKU',
  VARIATIONS: 'Variations',
};

export const DEFAULT_LISTINGS_COLUMNS_PROPS = {
  [LISTING_COLUMNS.LISTING_TITLE]: {
    displayName: 'Listing Title',
  },
  [LISTING_COLUMNS.LISTING_ID]: {
    displayName: 'Listing ID',
    disabled: rowData => isChildRow(rowData) && rowData[LISTING_COLUMNS.CHANNEL] === Channels.EBay,
  },
  [LISTING_COLUMNS.FULFILLED_BY]: {
    ..._.pick(DEFAULT_FIELD_PROPS[FIELD_NAMES.FULFILLMENT_CHANNEL], ['displayName', 'options']),
    infoIcon: (
      <TooltipIcon
        variant="inline"
        title="Indicates whether the orders of this listing are fulfilled by Merchant or by Amazon (FBA)"
      />
    ),
  },
  [LISTING_COLUMNS.QUANTITY]: {
    disabled: rowData => isParentRow(rowData),
    icon: rowData => {
      let lastSyncedOn;
      if (rowData.LastSyncedOn) {
        lastSyncedOn = extractDateTime(rowData.LastSyncedOn);
      }
      if (rowData.Error) {
        return <TooltipIcon title={`Synced failed on ${lastSyncedOn}`} icon={SyncProblemIcon} />;
      } else if (!rowData.QuantitySyncEnabled) {
        return <TooltipIcon title="Sync OFF" icon={SyncDisabledIcon} />;
      } else {
        const syncingElement = <TooltipIcon title="Syncing" icon={SyncIcon} />;
        const status = rowData.QuantityStatus;
        switch (status) {
          case SYNC_STATUS.PENDING:
          case SYNC_STATUS.PROCESSING:
            return syncingElement;
          case SYNC_STATUS.SYNCED:
            return <TooltipIcon title={`Last synced on ${lastSyncedOn}`} icon={DoneIcon} />;
          default:
            return syncingElement;
        }
      }
    },
  },
  [LISTING_COLUMNS.PRICE]: {
    disabled: rowData => isParentRow(rowData),
  },
  [LISTING_COLUMNS.VARIATIONS]: {
    displayName: 'Listing Variations',
  },
  [LISTING_COLUMNS.PRODUCT_SKU]: {
    displayName: 'Product SKU',
  },
  [LISTING_COLUMNS.CHANNEL]: {
    disabled: rowData => isChildRow(rowData),
  },
};

export const PRODUCT_ATTRIBUTES_SECTION = 'Product attributes';
